import { Link, Text, VStack } from '@direct-frontend/components';
import { DrawerHeader } from '@/shared/components/Drawer';
import { formatPhoneNumber } from '@/shared/lib/formatPhoneNumber';
import { type RequestContext } from '@/shared/lib/requestContext';

interface LoyaltyRegistrationErrorProps {
    userPhone: string;
    phones: RequestContext['company']['phones'];
    emails: RequestContext['company']['emails'];
}

export const LoyaltyRegistrationError = (props: LoyaltyRegistrationErrorProps) => {
    const { userPhone, phones, emails } = props;

    const phone = formatPhoneNumber(phones?.[0]?.value);
    const email = emails?.[0]?.value;

    return (
        <VStack gap="16">
            <DrawerHeader title="Свяжитесь со службой поддержки" />

            <VStack gap="8">
                <Text size="mc">
                    К сожалению, возникла ошибка при подключении к программе лояльности. Мы заметили, что номер телефона
                    <br />
                    {formatPhoneNumber(userPhone)}&nbsp;уже зарегистрирован в программе лояльности.
                </Text>

                <Text size="mc">
                    Чтобы мы помогли вам быстрее, пожалуйста, свяжитесь со службой поддержки удобным для вас способом.
                </Text>

                {phone && (
                    <VStack gap="4">
                        <Text size="s" role="supplementary">
                            Телефон
                        </Text>

                        <Link href={`tel:${phone}`}>
                            <Text size="mc">{phone}</Text>
                        </Link>
                    </VStack>
                )}

                {email && (
                    <VStack gap="4">
                        <Text size="s" role="supplementary">
                            Email
                        </Text>

                        <Link href={`mailto:${email}`}>
                            <Text size="mc">{email}</Text>
                        </Link>
                    </VStack>
                )}
            </VStack>
        </VStack>
    );
};
